import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/App/App';
import { ApolloClient, ApolloProvider, InMemoryCache } from '@apollo/client';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import { ColorModeScript } from '@chakra-ui/react';
import { customTheme } from './theme/customTheme';

const client = new ApolloClient({
	uri: 'https://jhgg2etdvvaszlfrr3zjww7gru.appsync-api.eu-west-1.amazonaws.com/graphql',
	cache: new InMemoryCache(),
	headers: {
		'x-api-key': 'da2-umx34azugvgcpph7bqpuximlbm',
	},
});

Sentry.init({
	dsn: 'https://9141aadf08b7481b860afef5c4412666@o1300283.ingest.sentry.io/6534482',
	integrations: [new BrowserTracing()],
	tracesSampleRate: 1.0,
});

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
	<React.StrictMode>
		<ApolloProvider client={client}>
			<ColorModeScript initialColorMode={customTheme.config.initialColorMode} />
			<App />
		</ApolloProvider>
	</React.StrictMode>
);

// @ts-ignore
if (module.hot) {
	// @ts-ignore
	module.hot.accept('./components/App/App', () => {
		/* eslint-disable global-require */
		const NextApp = require('./components/App/App').default;
		// @ts-ignore
		ReactDOM.render(<NextApp />, rootElement);
	});
}
